import { render, staticRenderFns } from "./tool.file.metadata.vue?vue&type=template&id=376c3b21&scoped=true&"
import script from "./tool.file.metadata.vue?vue&type=script&lang=js&"
export * from "./tool.file.metadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c3b21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376c3b21')) {
      api.createRecord('376c3b21', component.options)
    } else {
      api.reload('376c3b21', component.options)
    }
    module.hot.accept("./tool.file.metadata.vue?vue&type=template&id=376c3b21&scoped=true&", function () {
      api.rerender('376c3b21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tool/file/tool.file.metadata.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/tool/file/tool.file.metadata.vue
// module id = 712
// module chunks = 3